module.exports = __webpack_public_path__ + "static/media/individual.0030be10.webp";